var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientNursePresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.63,19a1.91,1.91,0,0,0-1.21-.06c-1,.23-4.1,3.09-4.56,3.1s-3.31-2.82-4.3-3.09a1.71,1.71,0,0,0-1.16,0,10.24,10.24,0,0,0-2.86,1.78A15.52,15.52,0,0,0,5.88,32.87c0,2.38,7,2,14,2s14.21.64,14.21-2C34.12,26.44,30.89,21.17,25.63,19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65,10a6.74,6.74,0,0,0-.21,1.63,6.56,6.56,0,0,0,13.12,0A6.74,6.74,0,0,0,26.35,10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.23,4.62A19.55,19.55,0,0,0,20,4.08a19.55,19.55,0,0,0-5.23.54A1.54,1.54,0,0,0,13.5,6.18V8.9h13V6.18A1.54,1.54,0,0,0,25.23,4.62ZM21.57,7H20.52V8.1h-1V7H18.43V6h1.05V4.88h1V6h1.05Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientNursePresent);
export default __webpack_public_path__ + "static/media/client-nurse-present.584b27bc111784d07beb1bb7c6f50dab.svg";
export { ForwardRef as ReactComponent };